module.exports = __webpack_public_path__ + "img/user05.b138f063.png";